import {cloneObject, until} from 'helpers/helpers';
import classNames from './filter-drop-down.module.css';
import Styles from '../../viewJob/view-job.module.css';
import {Controller, useForm} from 'react-hook-form';
import * as yup from 'yup';
import {useHistory} from 'react-router-dom';
import {yupResolver} from '@hookform/resolvers/yup';
import {CustomSelect} from 'erp-react-components';
import LeftIcon from 'images/svg/Icon feather-arrow-left.svg';
import {
  fetchBranchAPI,
  fetchContractTypeListAPI,
  fetchDepartmentAPI,
} from './filter.api';
import {useContext, useEffect, useMemo, useState} from 'react';
import toastService from 'components/Toasts/toast-service';
import {useTranslation} from 'react-i18next';
import moment from 'moment';
import flagIcon from 'images/svg/Group 36510.svg';
import {AuthContext} from 'contexts/auth.context';

interface FilterDropDownProps {
  setFilters?: (v) => void;
  filter?: any;
  dropdown?: boolean;
  viewJob?: any;
  backBtnDisable?: boolean;
  module?: string;
}

const FilterDropDown = ({
  setFilters,
  filter,
  dropdown,
  viewJob,
  backBtnDisable,
  module,
}: FilterDropDownProps) => {
  const {t} = useTranslation();
  const history = useHistory();
  const schema = yup.object().shape({});
  const defaultValues = {
    branchIds: null,
    departmentIds: null,
    contractTypes: null,
    isRemote: null,
  };
  const [branchOptions, setBranchOptions] = useState([]);
  const [departmentOptions, setdepartmentOptions] = useState([]);
  const [contractTypeList, setContractTypeList] = useState([]);
  const authProvider = useContext(AuthContext);
  const userDetails = authProvider.userDetails;
  const {
    control,
    formState: {errors},
    reset,
  } = useForm({
    defaultValues: cloneObject(defaultValues),
    resolver: yupResolver(schema),
    mode: 'onBlur',
    reValidateMode: 'onChange',
  });

  function handleRedirect(type) {
    if (type === 'apply')
      history.push({
        pathname: '/internal/jobboard',
      });
    else
      history.push({
        pathname: '/jobboard/applied',
      });
  }

  useMemo(() => {
    if (module === 'job-list') {
      branchList({});
      departmentList({});
    }
  }, []);

  useEffect(() => {
    if (filter && Object.keys(filter).length === 0) {
      reset({
        branchIds: null,
        departmentIds: null,
        contractTypes: null,
        isRemote: null,
      });
    }
  }, [filter]);

  async function branchList(filters) {
    const [err, result] = await until(
      fetchBranchAPI({...filters, limit: 2000}),
    );
    if (err) {
      toastService.error({msg: err.message});
      return console.error(err);
    }
    if (result?.data)
      return setBranchOptions(
        (result.data || []).map((c) => ({value: c.id, label: c.name})),
      );
  }

  async function departmentList(filters) {
    const [err, result] = await until(
      fetchDepartmentAPI({...filters, limit: 2000}),
    );
    if (err) {
      toastService.error({msg: err.message});
      return console.error(err);
    }
    if (result?.data)
      return setdepartmentOptions(
        (result.data?.data || []).map((c) => ({value: c.id, label: c.name})),
      );
  }

  async function fetchContractTypeListData(filters) {
    const [err, res] = await until(fetchContractTypeListAPI(filters));
    if (err) {
      setContractTypeList([]);
      return console.error(err);
    }
    return setContractTypeList(
      (res?.data || []).map((c) => ({value: c.name, label: c.name})),
    );
  }

  return (
    <>
      {dropdown ? (
        <div className={classNames['filter-drop-down-container']}>
          <div className={`mr-2 ${classNames['drop-down-location-width']}`}>
            <Controller
              control={control}
              name="branchIds"
              render={({field: {name, value, onChange, onBlur}}) => {
                return (
                  <CustomSelect
                    name={name}
                    placeholder={t('Location')}
                    searchOptions={true}
                    multiSelect
                    style={{border: '1px solid #C6C9E1'}}
                    options={branchOptions}
                    value={value}
                    onChange={(currentVal, val) => {
                      onChange(currentVal);
                      if (currentVal?.length) {
                        fetchContractTypeListData({
                          branchIds: currentVal,
                        });
                        setFilters({...filter, branchIds: currentVal});
                      } else {
                        setContractTypeList([]);
                        setFilters({...filter, branchIds: []});
                      }
                    }}
                    onBlur={onBlur}
                  />
                );
              }}
            />
          </div>
          <div className={`mr-2 ${classNames['drop-down-department-width']}`}>
            <Controller
              control={control}
              name="departmentIds"
              render={({field: {name, value, onChange, onBlur}}) => {
                return (
                  <CustomSelect
                    name={name}
                    placeholder={t('Department')}
                    searchOptions={true}
                    multiSelect
                    style={{border: '1px solid #C6C9E1'}}
                    options={departmentOptions}
                    value={value}
                    onChange={(currentVal, val) => {
                      onChange(currentVal);
                      setFilters({...filter, departmentIds: currentVal});
                    }}
                    onBlur={onBlur}
                  />
                );
              }}
            />
          </div>
          <div className={`mr-2 ${classNames['drop-down-type-width']}`}>
            <Controller
              control={control}
              name="contractTypes"
              render={({field: {name, value, onChange, onBlur}}) => {
                return (
                  <CustomSelect
                    name={name}
                    placeholder={t('Employment Type')}
                    searchOptions={true}
                    multiSelect
                    style={{border: '1px solid #C6C9E1'}}
                    options={contractTypeList}
                    value={value}
                    onChange={(currentVal, val) => {
                      onChange(currentVal);
                      setFilters({...filter, contractTypes: currentVal});
                    }}
                    onBlur={onBlur}
                  />
                );
              }}
            />
          </div>
          <div className={`mr-2 ${classNames['drop-down-type-width']}`}>
            <Controller
              control={control}
              name="isRemote"
              render={({field: {name, value, onChange, onBlur}}) => {
                return (
                  <CustomSelect
                    name={name}
                    placeholder={t('Workplace Type')}
                    searchOptions={true}
                    multiSelect={false}
                    style={{border: '1px solid #C6C9E1'}}
                    options={[
                      {
                        label: t('JOB_BOARD_Hybrid'),
                        value: '2',
                      },
                      {
                        label: t('JOB_BOARD_Remote'),
                        value: '1',
                      },
                      {
                        label: t('JOB_BOARD_Studio'),
                        value: '0',
                      },
                    ]}
                    value={value}
                    onChange={(currentVal, val) => {
                      onChange(currentVal);
                      setFilters({...filter, isRemote: currentVal});
                    }}
                    onBlur={onBlur}
                  />
                );
              }}
            />
          </div>
        </div>
      ) : (
        <div className={classNames['filter-drop-down-info']}>
          <div
            className={`${
              !backBtnDisable
                ? classNames['filter-drop-down-info-details']
                : classNames['filter-drop-down-info-details-success']
            }`}
          >
            {!backBtnDisable &&
            module != 'view-application' &&
            module != 'profile' ? (
              <div className={classNames['header-m']}>
                <div className={classNames['back-arrow-container']}>
                  <img
                    className={classNames['back-arrow']}
                    src={LeftIcon}
                    onClick={() => handleRedirect('apply')}
                  ></img>
                </div>
                <div className={classNames['appliying-text']}>
                  {t('View_Job_Applying for')}
                </div>
              </div>
            ) : (
              <></>
            )}
            <div className={classNames['header-m']}>
              {module === 'view-application' ? (
                <div className={classNames['back-arrow-container']}>
                  <img
                    className={classNames['back-arrow']}
                    src={LeftIcon}
                    onClick={() => handleRedirect('view-application')}
                  ></img>
                </div>
              ) : (
                <></>
              )}
              {module !== 'profile' && viewJob ? (
                <>
                  <div
                    className={classNames['position-dept-text']}
                    style={
                      module === 'view-application' ? {marginLeft: '0'} : {}
                    }
                  >
                    {(viewJob?.job_posted_to || []).some((p) => {
                      return p?.job_post_type === 'internal';
                    }) ? (
                      <img src={flagIcon} />
                    ) : (
                      <></>
                    )}
                    {viewJob?.position_number || ''} - {viewJob?.role || ''}{' '}
                  </div>
                </>
              ) : (
                <></>
              )}

              {module !== 'profile' && viewJob ? (
                <div className={classNames['department-view']}>
                  {' '}
                  {viewJob?.is_remote_job == 2 ? (
                    <span className={Styles['hybird-status']}>
                      {t('JOB_BOARD_Hybrid')}
                    </span>
                  ) : viewJob?.is_remote_job == 1 ? (
                    <span className={Styles['remort-status']}>
                      {t('JOB_BOARD_Remote')}
                    </span>
                  ) : viewJob?.is_remote_job == 0 ? (
                    <span className={Styles['onsite-status']}>
                      {t('JOB_BOARD_Studio')}
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <></>
              )}
            </div>
            <div
              className={
                classNames['branch-text'] + ' ' + classNames['dm-view']
              }
            >
              {viewJob?.preferred_branches?.length ||
              viewJob?.branches?.length ? (
                <div>
                  {(viewJob?.preferred_branches || viewJob?.branches || [])
                    .map((b) => {
                      return b?.name;
                    })
                    ?.join(', ')}
                </div>
              ) : (
                <></>
              )}
            </div>

            {module !== 'profile' && viewJob ? (
              <div
                className={classNames['dept-type-ex']}
                style={module === 'view-application' ? {marginLeft: 0} : {}}
              >
                <div className={classNames['dept-text']}>
                  {viewJob?.department?.name || ''}
                </div>
                {viewJob?.preferred_branches?.length ||
                viewJob?.branches?.length ? (
                  <div
                    className={
                      classNames['contract-text'] + ' ' + classNames['md-view']
                    }
                  >
                    {(viewJob?.preferred_branches || viewJob?.branches || [])
                      .map((b) => {
                        return b?.name;
                      })
                      ?.join(', ')}
                  </div>
                ) : (
                  <></>
                )}
                <div className={classNames['contract-text']}>
                  {viewJob?.contract_type || ''}
                </div>
                <div className={classNames['ex-text']}>{`${
                  (viewJob?.experience_from && viewJob?.experience_to) ||
                  viewJob?.experience_to
                    ? `${viewJob?.experience_from || 0} - ${
                        viewJob?.experience_to
                      } ${'Years'}`
                    : t('JOB_BOARD_Fresher')
                }`}</div>
                {module !== 'profile' && viewJob ? (
                  <div className={classNames['deprt-text-mb']}>
                    {' '}
                    {viewJob?.is_remote_job == 2 ? (
                      <span className={Styles['hybird-status']}>
                        {t('JOB_BOARD_Hybrid')}
                      </span>
                    ) : viewJob?.is_remote_job == 1 ? (
                      <span className={Styles['remort-status']}>
                        {t('JOB_BOARD_Remote')}
                      </span>
                    ) : viewJob?.is_remote_job == 0 ? (
                      <span className={Styles['onsite-status']}>
                        {t('JOB_BOARD_Studio')}
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <></>
            )}
            {module === 'view-application' && viewJob ? (
              <div className={classNames['view-application-applied-text']}>
                <div className={classNames['applied-text']}>
                  {t('Applications_Applied on')}
                </div>
                <div className={classNames['applied-date']}>
                  {moment(
                    viewJob?.created_at ||
                      viewJob?.hiring_request?.created_at ||
                      '',
                  ).format('D MMM YYYY, h:mm A')}
                </div>
              </div>
            ) : (
              <></>
            )}
            {module === 'profile' ? (
              <div>
                <div className={classNames['profile-header']}>
                  <img
                    className={`${classNames['back-arrow']} ${classNames['profile-back-btn']}`}
                    src={LeftIcon}
                    onClick={() => handleRedirect('view-application')}
                  ></img>
                  {`${userDetails?.firstName || ''} ${
                    userDetails?.middleName || ''
                  } ${userDetails?.lastName || ''}`}
                </div>
                <div className={classNames['profile-header-dept']}>{`${
                  userDetails?.department || ''
                }, ${userDetails?.location || ''}`}</div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FilterDropDown;
